import { Ic } from './Icons';
import './Fab.css';

/** Floating action button — "+ Серия". Opens the BatchModal which
 *  creates a Job batch (Phase 3.5). Phase 3.14.1 unified the UI noun
 *  to «Серия» (previously was «Пакет» in 3.6); the code identifier
 *  stays ``batch`` for consistency with the CLI command and API
 *  endpoint — internal naming intentionally diverges from UI copy. */
export function Fab({ onClick, label = 'Серия' }: { onClick?: () => void; label?: string }) {
  return (
    <button className="fab" onClick={onClick} aria-label={label}>
      <Ic.plus />
      <span>{label}</span>
    </button>
  );
}
